const headRowsEquip = {
  name: 'Tipo de Equipo',
  equipmentGroup: 'Grupo',
  checklist: 'Checklist',
}

export default headRowsEquip;
